export function resolveOption<T>(condition: boolean, alternativeOption: T | null | undefined, primaryOption: T): T {
  return condition && alternativeOption ? alternativeOption : primaryOption;
}
